export default "__VITE_ASSET__WFvedz05__"